import Styled from 'styled-components/macro';
import {CSS_CONSTANTS} from '../../../../css_variables';

export const DashboardWrapper = Styled.div`
   max-width: 2000px;
   background-color: ${CSS_CONSTANTS.v2_section_main_background};
   padding-top: 44px;
`;

export const Widgets = Styled.div`
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   align-items: flex-start;
   padding: 0px 0px 40px;
`;
